import { subscribeToNotifications } from "../channels/notification_channel";
import { activeNotificationFilter, withNotificationFilter } from "./notification_filters.js";

export default function registerNotifications(Alpine) {
  Alpine.store("notifications", {
    unreadCount: 0,

    init() {
      if (!document.getElementById("notification-dropdown")) return;

      this.fetchUnreadCount();
      subscribeToNotifications(Alpine);
    },

    async fetchUnreadCount() {
      try {
        const response = await fetch("/notifications/unread_count", {
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        });
        if (response.ok) {
          const data = await response.json();
          this.unreadCount = data.count;
        }
      } catch {
        // Silently fail on fetch errors
      }
    },

    // Marks what the dropdown's active tab shows: on Mentions, only mentions
    // and follow-up requests, so other unread alerts stay unread.
    async markAllRead() {
      try {
        const frame = document.getElementById("notification-list");
        const filter = activeNotificationFilter(frame);
        const token = document.querySelector("meta[name=csrf-token]")?.content;
        const response = await fetch(withNotificationFilter("/notifications/mark_all_read", filter), {
          method: "PATCH",
          headers: {
            Accept: "application/json",
            "X-CSRF-Token": token,
            "X-Requested-With": "XMLHttpRequest"
          }
        });
        if (response.ok) {
          if (filter === "all") {
            this.unreadCount = 0;
          } else {
            this.fetchUnreadCount();
          }
          // Reload the notification list frame on the same tab
          if (frame) frame.src = withNotificationFilter("/notifications", filter);
        }
      } catch {
        // Silently fail
      }
    }
  });
}
